import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import i18n from 'i18n-react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import {
  APIHandler,
  AppRouter,
  CookieWarning,
  DataHandler,
  MobileWarning,
  StorageHandler,
  SweetAlert,
  locales,
} from 'C4';
import { storageKeys, language, sentry } from 'settings';

import 'normalize.css/normalize.css';

import 'config/FontAwesome';
import 'assets/styles/styles.scss';

Sentry.init({
  ...sentry,
  integrations: [new Integrations.BrowserTracing()],
});

class App extends Component {
  constructor(props) {
    super(props);

    const mobileRegex = new RegExp('Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini', 'i');
    const mobilePathRegex = new RegExp('mobile', 'i');

    this.state = {
      onMobile: mobileRegex.test(window.navigator.userAgent) && !mobilePathRegex.test(window.location.pathname),
      askedBefore: null,
      appLanguage: null,
      appId: null,
    };

    this.setAsked = this.setAsked.bind(this);
  }

  componentDidMount() {
    this.checkMobile();
    this.setLanguage();
    this.getAppId();
  }

  componentDidUpdate() {
    const { appLanguage } = this.state;
    const { texts } = i18n;

    if (JSON.stringify(appLanguage) !== JSON.stringify(texts)) {
      i18n.setTexts(appLanguage);
    } 
  }

  async getAppId() {
    const appId = await DataHandler.matchAppId();
    const localId = await StorageHandler.load(storageKeys.appId);

    if (localId !== appId) {
      StorageHandler.removeKeys(
        Object.keys(storageKeys).filter((key) => ![storageKeys.appId, storageKeys.lang].includes(storageKeys[key])),
      );
    }

    StorageHandler.save(storageKeys.appId, appId, 86400000 * 365);
    this.setState({ appId });

    window.appId = appId;
  }

  async getLocation() {
    console.log('fff');
    console.log(window.location.hostname );
    const { countryCode, country } = (await APIHandler.getLocation()) || {};
    const languageData = {
      country: 'United_States',
      code: 'US',
      langFile: 'en',
    };

    const availableLanguages = language
      .map(({ code }) => (typeof code === 'string' ? code : code.map((c) => c.toLowerCase())))
      .flat();
    if (countryCode) {
      Object.assign(languageData, {
        country: 'United_States',
        code: countryCode,
        langFile: 'en',
      });
    }

    if (countryCode && country && availableLanguages.includes(countryCode.toLowerCase())) {
      const [file] = language
        .filter(({ code }) => (typeof code === 'string' ? code === countryCode : code.includes(code)))
        .map(({ langFile }) => langFile);

      Object.assign(languageData, {
        country: country.replace(/[ ]/g, '_'),
        code: countryCode.toLowerCase(),
        langFile: file,
      });
    }

    // Set location based on domain
    if (window.location.hostname === 'localhost') {
      Object.assign(languageData, {
        country: 'Germany',
        code: 'de',
        langFile: 'de',
      });

      StorageHandler.save(storageKeys.appId, 808, 86400000 * 365);
      this.setState({ appId: 808 });
      window.appId = 808;

    } else if (window.location.hostname === 'canadaspecialistprogram.de' || window.location.hostname === 'www.canadaspecialistprogram.de') {
      Object.assign(languageData, {
        country: 'Germany',
        code: 'de',
        langFile: 'de',
      });


      StorageHandler.save(storageKeys.appId, 808, 86400000 * 365);
      this.setState({ appId: 808 });
      window.appId = 808;

    } else if (window.location.hostname === 'specialistesducanada.fr' || window.location.hostname === 'www.specialistesducanada.fr') {
      Object.assign(languageData, {
        country: 'France',
        code: 'fr',
        langFile: 'fr',
      });


      StorageHandler.save(storageKeys.appId, 807, 86400000 * 365);
      this.setState({ appId: 807 });
      window.appId = 807;

    } else if (window.location.hostname === 'www.canadaspecialist.co.uk' || window.location.hostname === 'www.canadaspecialist.co.uk') {
      Object.assign(languageData, {
        country: 'United Kingdom',
        code: 'gb',
        langFile: 'en',
      });

      StorageHandler.save(storageKeys.appId, 807, 86400000 * 365);
      this.setState({ appId: 807 });
      window.appId = 807;
    } else if (window.location.hostname === 'canadaspecialist.com.au' || window.location.hostname === 'www.canadaspecialist.com.au') {
      Object.assign(languageData, {
        country: 'Australia',
        code: 'au',
        langFile: 'en',
      });

      StorageHandler.save(storageKeys.appId, 854, 86400000 * 365);
      this.setState({ appId: 854 });
      window.appId = 854;
    } else if (window.location.hostname === 'canadaspecialistprogram.ca' || window.location.hostname === 'www.canadaspecialistprogram.ca') {
      Object.assign(languageData, {
        country: 'Canada',
        code: 'caEn',
        langFile: 'en',
      });

      StorageHandler.save(storageKeys.appId, 787, 86400000 * 365);
      this.setState({ appId: 787 });
      window.appId = 787;
    } else if (window.location.hostname === 'canadaspecialistprogram.us' || window.location.hostname === 'www.canadaspecialistprogram.us') {
      Object.assign(languageData, {
        country: 'United States',
        code: 'us',
        langFile: 'en',
      });

      StorageHandler.save(storageKeys.appId, 787, 86400000 * 365);
      this.setState({ appId: 787 });
      window.appId = 787;
    } else if (window.location.hostname === 'canadaspecialist.us ' || window.location.hostname === 'www.canadaspecialist.us') {
      Object.assign(languageData, {
        country: 'United States',
        code: 'us',
        langFile: 'en',
      });

      StorageHandler.save(storageKeys.appId, 787, 86400000 * 365);
      this.setState({ appId: 787 });
      window.appId = 787;
    } else if (window.location.hostname === 'canadaspecialistprogram.com' || window.location.hostname === 'www.canadaspecialistprogram.com') {
      Object.assign(languageData, {
        country: 'United States',
        code: 'us',
        langFile: 'en',
      });

      StorageHandler.save(storageKeys.appId, 787, 86400000 * 365);
      this.setState({ appId: 787 });
      window.appId = 787;
    } else if (window.location.hostname === 'www.canadaspecialist.mx' || window.location.hostname === 'www.canadaspecialist.mx') {
      Object.assign(languageData, {
        country: 'Mexico',
        code: 'mx',
        langFile: 'es',
      });

      StorageHandler.save(storageKeys.appId, 831, 86400000 * 365);
      this.setState({ appId: 831 });
      window.appId = 831;
    } else if (window.location.hostname === 'canadaspecialist.com' || window.location.hostname === 'www.canadaspecialist.com') {
      Object.assign(languageData, {
        country: 'United States',
        code: 'us',
        langFile: 'en',
      });

      StorageHandler.save(storageKeys.appId, 787, 86400000 * 365);
      this.setState({ appId: 787 });
      window.appId = 787;
    } else if (window.location.hostname === 'programmedesspecialistesducanada.ca' || window.location.hostname === 'www.programmedesspecialistesducanada.ca') {
      Object.assign(languageData, {
        country: 'Canada',
        code: 'caFr',
        langFile: 'fr',
      });

      StorageHandler.save(storageKeys.appId, 807, 86400000 * 365);
      this.setState({ appId: 807 });
      window.appId = 807;
    } else if (window.location.hostname === 'specialistesducanada.ca' || window.location.hostname === 'www.specialistesducanada.ca') {
      Object.assign(languageData, {
        country: 'Canada',
        code: 'caFr',
        langFile: 'fr',
      });

      StorageHandler.save(storageKeys.appId, 807, 86400000 * 365);
      this.setState({ appId: 807 });
      window.appId = 807;
    }

    console.log(languageData);
    StorageHandler.save(storageKeys.lang, languageData);
    this.setState({ appLanguage: locales[languageData.langFile] || locales.en });
  }

  async setLanguage() {
    const languageExists = await StorageHandler.exists(storageKeys.lang);
    if (languageExists) {
      const { langFile } = (await StorageHandler.load(storageKeys.lang)) || {};
      this.setState({ appLanguage: locales[langFile] || locales.en });
    } else {
      this.getLocation();
    }
  }

  setAsked() {
    this.setState({ askedBefore: true });
    StorageHandler.save('askedMobile', true);
  }

  async checkMobile() {

    // Temp redirect to subscribe page
    if (window.location.hostname === 'www.canadaspecialistprogram.co.uk' || window.location.hostname === 'canadaspecialistprogram.co.uk' || window.location.hostname === 'canadaspecialists.co.uk') {
      window.location.replace("https://www.canadaspecialist.co.uk");
    }

    if (window.location.hostname === 'landing-canada.netlify.app') {
      window.location.replace("https://csp.travpromobile.com");
    }

    if (window.location.hostname === 'canadaspecialist.jp' || window.location.hostname === 'www.canadaspecialist.jp') {
      window.location.replace("https://csp.travpromobile.com");
    }


    if (window.location.hostname === 'canadaspecialist.us' || window.location.hostname === 'www.canadaspecialist.us') {
      window.location.replace("https://www.canadaspecialistprogram.com");
    }

    if (window.location.hostname === 'canadaspecialist.com' || window.location.hostname === 'www.canadaspecialist.com') {
      window.location.replace("https://www.canadaspecialistprogram.com");
    }

    
    const askedBefore = await StorageHandler.load('askedMobile');
    this.setState({ askedBefore });
  }

  render() {
    const { onMobile, askedBefore, appLanguage, appId } = this.state;

    return (
      <div className="container__router">
        {!window.navigator.cookieEnabled && <CookieWarning />}
        {(!onMobile || askedBefore) && appId && <AppRouter key={JSON.stringify(appLanguage)} />}
        {onMobile && !askedBefore && (
          <SweetAlert
            trigger={onMobile}
            {...{
              title: '',
              html: <MobileWarning />,
              customClass: 'mobileWarning',
              confirmButtonText: 'Continue >',
              showConfirmButton: false,
              onClose: this.setAsked,
            }}
          />
        )}
      </div>
    );
  }
}

ReactDOM.render(<App />, document.getElementById('root'));
